module.exports = __webpack_public_path__ + "static/Background1-49817e6cd8af9d9f8314db659de8eeb4.jpg";